
import { mixins, Options, Prop } from 'vue-property-decorator'
import { Action } from 'vuex-class'

import { SearchContents, SearchContentTypesEnum, SearchMode, SearchResult } from '@rtl/api'

import { SEARCH_ACTION, SEARCH_NAMESPACE, SearchPayload } from '../../store'
import ContentCardList from '../components/content/ContentCardList.vue'
import Search from '../components/icons/Search.vue'
import GetPageMixin from '../mixins/GetPageMixin'

import WidgetMixin, { WidgetMeta } from './WidgetMixin'

export const meta: WidgetMeta = {
  label: 'Content kereső',
  fields: {
    title: {
      label: 'Címsor',
      type: String,
      default: ''
    },
    siteId: {
      label: 'Egyedi műsor id',
      type: String,
      default: ''
    }
  }
}

@Options({
  name: 'ContentSearchWidget',
  components: {
    ContentCardList,
    Search
  }
})
export default class ContentSearchWidget extends mixins(WidgetMixin, GetPageMixin) {
  @Action(SEARCH_ACTION.SEARCH, { namespace: SEARCH_NAMESPACE })
  searchAction!: (payload: SearchPayload) => Promise<SearchResult>

  @Prop({
    type: String
  })
  readonly siteId: string | undefined

  searchText = ''
  searchLoading = false
  searchResults: SearchContents | null = null

  get scopedSiteId () {
    return this.siteId ?? this.page?.site?.id
  }

  async searchByInput () {
    if (this.searchText) {
      this.searchLoading = true
      const result = await this.searchAction({
        searchText: this.searchText,
        contentTypes: [SearchContentTypesEnum.News, SearchContentTypesEnum.Gallery, SearchContentTypesEnum.Longvideo],
        ...this.scopedSiteId ? {
          searchMode: SearchMode.SiteOnly,
          siteId: this.scopedSiteId,
        } : {},
        offset: 0,
        limit: 8
      })
      this.searchLoading = false
      this.searchResults = result.data.other ?? null
    } else {
      this.searchResults = null
    }
  }
}
